import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';

import { initialState } from './PanelOption.redux';

const selectDomain = (state: RootState) => state?.panelOption || initialState;

export const selectPanel = createSelector([selectDomain], panelOption => panelOption);
